import PropTypes from 'prop-types';
import getMessage from '../utils/getMessage';

const CloseButton = ({ closeToast }) => (
  <button
    className="digi-button--transparent-bg digi-button--hover-light-bg digi-button--round"
    style={{width: '2.5em'}}
    type="button"
    onClick={closeToast}
    title={getMessage('close')}
  >
    &#10006;
  </button>
  
);

CloseButton.propTypes = {
  closeToast: PropTypes.func,
};

export default CloseButton;
